import styled from 'styled-components';

const AutoCarouselFGStyled = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: space-around;
  align-items: center;
  width: 1016px;
  background: #fbf1e6;
  border-radius: 25px;
  padding: 31px 30px 38px 30px;

  .btn {
    display: flex;
    align-items: center;
    justify-content: center;
    margin-top: 19px;
    margin-left: -33px;
  }
  .mobile{
    @media(min-width: 800px){
      display: none;
    }
  }
  .desktop{
    @media(max-width: 800px){
      display: none;
    }
  }

  .info {
    font-family: 'Century Gothic';
    font-style: normal;
    font-weight: 400;
    font-size: 12px;
    line-height: 140%;
    text-align: center;
    color: #4C0D18;
    margin-top: 1rem;
  
  }
    
  @media screen and (max-width: 800px) {
    width: -webkit-fill-available;
    height: auto;
    padding: 20px;

    .btn {
      margin-left: 0px !important;
    }
  }
`;

export default AutoCarouselFGStyled;
